
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/terms",
      function () {
        return require("private-next-pages/article/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/terms"])
      });
    }
  